import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './ProductionUploadFolder.css';

const PRODUCTION_ROOT =
  process.env.REACT_APP_PRODUCTION_START_PATH || '/production';

function ProductionUploadFolder({ currentPath, userId, onFolderUploaded }) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={PRODUCTION_ROOT}
      sessionPrefix="production_folder"
    />
  );
}

ProductionUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default ProductionUploadFolder;
